import {
    StyleSheet, View, Text
} from "react-native";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import { FONT } from "../../../value/staticValues";
import { useTranslation } from "react-i18next";
import ContentBox from "../../base/tamplate/ContentBox";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";
import ListTable from "../../base/table/listTable";
import { HostClusterDetailData, HostClusterTableData, actionMenus, initHostClusterDetailData } from "./HostClusterHostData";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";


interface HostClusterDetailProps extends ContentContainerProps {
    clickActionMenu: Function;
    selectRow: Function;
    fetchData: any;
    pageCount: number;
    headers: any;
    totalItemCount: number;
    refreshYn: boolean;
    loadMainDataYn: boolean;
    tableData: HostClusterTableData[];
    detailData: HostClusterDetailData;
}



export default function HostClusterDetail(props:HostClusterDetailProps) {
    const { t } = useTranslation();

    return (
        <ContentBox title={t("HOST_CLUSTER_DETAIL_TITLE")} subtitle={t("HOST_CLUSTER_DETAIL_SUBTITLE")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={style.topContainer}>
                <View style={{
                    flexDirection: "row", alignItems: "center", justifyContent: "flex-end"
                }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Text style={style.dateTitle}>
                            {t("LAST_UPDATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData.update_ts ? parseLocaleDatetime(props.detailData.update_ts) : ""}
                        </Text>
                    </View>
                    <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 30 }}>
                        <Text style={style.dateTitle}>
                            {t("CREATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData.create_ts ? parseLocaleDatetime(props.detailData.create_ts) : ""}
                        </Text>
                    </View>
                </View>

                <View style={{...style.boxContainer, height: 280}}>
                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                        <Text style={style.boxContentTitle}>
                            {t("BASE_INFO_TEXT")}
                        </Text>
                    </View>
                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                        <Text style={style.boxContentHeaderText}>
                            {t("HOST_CLUSTER_NAME_TEXT")}
                        </Text>
                        <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 14}}>
                            {props.detailData.host_cluster_name}
                        </Text>
                        <div style={{paddingLeft: 10, paddingRight: 10,
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    borderRadius: 10,
                                    backgroundColor: "#b6bfce",
                                    fontFamily: FONT.REGULAR,
                                    fontSize: 12,
                                    color: "#fff"}}>
                                {
                                    props.detailData.host_cluster_type_code === "CMP" ? t("COMPUTE_TYPE_TEXT")
                                    : props.detailData.host_cluster_type_code === "MEM" ? t("MEMORY_TYPE_TEXT")
                                    : props.detailData.host_cluster_type_code === "GPU" ? t("GPU_TYPE_TEXT")
                                    : props.detailData.host_cluster_type_code === "STRG" ? t("STORAGE_TYPE_TEXT")
                                    : props.detailData.host_cluster_type_code === "NET" ? t("네트워크용")
                                    : t("NORMAL_TYPE_TEXT")
                                }
                        </div>
                    </View>

                    <View style={{flexDirection: "row"}}>
                        <View style={{width: 490}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>

                                <Text style={style.boxContentHeaderText}>
                                    {t("REGION_NAME_TEXT")}
                                </Text>
                                <Text style={style.boxContentDataText}>
                                    {props.detailData.region?.region_name || "-"}
                                </Text>
                            </View>
                        </View>
                        <View style={{width: 490}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>

                                <Text style={style.boxContentHeaderText}>
                                    {t("AZ_NAME_TEXT")}
                                </Text>
                                <View style={{flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
                                    <Text style={{...style.boxContentDataText, marginRight: 10}}>
                                        {props.detailData.availability_zone_name}
                                    </Text>
                                    {props.detailData.availability_zone?.availability_zone_id ? <StatusStableImg/> : <StatusBlockImg/> }
                                    {
                                        props.detailData.availability_zone?.availability_zone_id? null :
                                        <Text style={{...style.boxContentDataText, marginRight: 10}}>
                                            {t("HOST_CLUSTER_NO_HOST_AZ_DOWN_TEXT")}
                                        </Text>
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={{flexDirection: "row"}}>
                        <View style={{width: 490}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>

                                <Text style={style.boxContentHeaderText}>
                                    {t("HOST_CLUSTER_HOST_COUNT_TEXT")}
                                </Text>
                                <Text style={style.boxContentBlueDataText}>
                                    {props.detailData.host_count}{t("UNIT_TEXT")}
                                </Text>
                            </View>
                        </View>

                    </View>
                </View>

                <View style={{...style.boxContainer, height: 720}}>
                    <View style={{flexDirection: "row", alignItems: "center"}}>
                        <Text style={{...style.boxContentTitle, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                            {t("HOST_CLUSTER_HOST_TEXT")}
                        </Text>
                    </View>
                    <View style={{marginTop: 24}}>
                        {
                            props.loadMainDataYn === true
                            ? <ListTable
                                id={"hostClusterHost"}
                                actionMenus={actionMenus}
                                actionMenuClickCb={props.clickActionMenu}
                                searchBarYn={true}
                                searchBarPlaceholder={t("HOST_CLUSTER_HOST_SEARCH_BAR_PLACEHOLDER_TEXT")}
                                pageYn={true}
                                rowCheckYn={true}
                                rowCheckCb={props.selectRow}
                                fetchDataCb={props.fetchData}
                                pageCount={props.pageCount}
                                pageSize={20}
                                tableHeaders={props.headers}
                                tableData={props.tableData}
                                totalItemCount={props.totalItemCount}
                                detailYn={true}
                                refreshYn={props.refreshYn}
                                canLoadYn={true}
                            />
                            : null
                        }
                    </View>
                </View>
            </View>
        </ContentBox>
    );
}

const style = StyleSheet.create({
    topContainer: {
        width: 1115,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateTitle: {
        marginRight: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateData: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentHeaderText: {
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    boxContentBlueDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#0853fb"
    }
});